"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _userenderscount = _interopRequireDefault(require("@hedtech/userenderscount"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var selector = function selector(state) {
  return state;
};
var ReduxStateDump = function ReduxStateDump() {
  (0, _userenderscount["default"])('ReduxStateDump');
  var state = (0, _reactRedux.useSelector)(selector);
  return /*#__PURE__*/_react["default"].createElement("pre", null, JSON.stringify(state, undefined, 4));
};
var _default = exports["default"] = ReduxStateDump;